import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { History } from 'lucide-react';

const ACTION_COLORS = { created: '#10B981', updated: '#3B82F6', deleted: '#EF4444' };

export function ActivityLogDialog({ open, onOpenChange, campaign, logs, loading }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg rounded-none border-zinc-200 max-h-[90vh] overflow-y-auto" data-testid="activity-log-dialog">
        <DialogHeader><DialogTitle className="text-xl font-bold tracking-tight flex items-center gap-2"><History size={20} /> Activity Log</DialogTitle></DialogHeader>
        {campaign && (
          <div className="space-y-4 mt-4">
            <div className="bg-zinc-50 border border-zinc-200 p-3"><div className="font-medium text-zinc-900">{campaign.name}</div><div className="text-xs text-zinc-500">{campaign.client_name}</div></div>
            {loading ? (
              <div className="py-8 text-center"><div className="w-5 h-5 border-2 border-zinc-300 border-t-zinc-900 rounded-full animate-spin mx-auto" /></div>
            ) : logs.length === 0 ? (
              <div className="py-8 text-center text-sm text-zinc-400">No activity recorded yet</div>
            ) : (
              <div className="space-y-0">
                {logs.map((log, i) => (
                  <div key={log.id || i} className="flex gap-3 py-3 border-b border-zinc-100 last:border-0" data-testid={`log-entry-${i}`}>
                    <div className="w-2 h-2 rounded-full mt-1.5 shrink-0" style={{ backgroundColor: ACTION_COLORS[log.action] || '#71717A' }} />
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-bold px-1.5 py-0.5" style={{ backgroundColor: (ACTION_COLORS[log.action] || '#71717A') + '18', color: ACTION_COLORS[log.action] || '#71717A' }}>{log.action}</span>
                        <span className="text-xs text-zinc-400">{log.user_name}</span>
                      </div>
                      {log.details && <p className="text-xs text-zinc-500 mt-1 truncate">{log.details}</p>}
                      <p className="text-xs text-zinc-300 font-mono mt-1">{log.created_at ? log.created_at.replace('T', ' ').split('.')[0] : ''}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
